import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const ForumPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Forum}
        fetchRecordsUrl={AdminReqUrls.admin__forum__mainPage_fetch_recordList}
        showMultipleDelete={true}
    />)
});
export default ForumPage;
